var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2293 4.31766L22.7066 12.3798L33.5647 10.6364L28.2083 20.2402L33.2212 30.0271L22.4328 27.8993L14.6738 35.6928L13.3633 24.7749L3.55461 19.8037L13.5335 15.1819L15.2293 4.31766Z",
    fill: "#00BA34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 24.4892L48.0567 30.7958L55 31.755L49.9467 36.6117L51.18 43.5108L45 40.205L38.8192 43.5108L40.0533 36.6117L35 31.755L41.9433 30.7958L45 24.4892Z",
    fill: "#0085FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9899 40.8644L25.5473 46.091L30.2045 48.5295L25.4058 50.6753L24.5261 55.8575L21.0029 51.9565L15.8019 52.7217L18.4232 48.1654L16.0887 43.4557L21.2326 44.5402L24.9899 40.8644Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3791,
    height: 31.3791,
    fill: "white",
    transform: "translate(0 8.1673) rotate(-16.9865)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(18.056 37.9823) rotate(19.7704)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars-icon.bbb75a89d18565b9acc8c2e76143c5c1.svg";
export { ForwardRef as ReactComponent };